// extracted by mini-css-extract-plugin
module.exports = {"root":"_254da2","headingContainer":"_596c5a","ratingText":"_1098ce","summary":"_da29df"};